import "react-datepicker/dist/react-datepicker.css";

import fr from "date-fns/locale/fr";
import { useCallback } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { FormHelperText } from "../_partials";
import { Day, Header, Input } from "../FormDate/_partials";
import { DatePortal } from "../FormDate/_partials/DatePortal";
import { DateFieldProps } from "../FormDate/DateField";
import styles from "../FormDate/DateField.module.scss";
import { useMonthsShown } from "../FormDate/useMonthsShown";
import timeStyles from "./DateTimeField.module.scss";

export interface DateTimeFieldProps extends DateFieldProps {}

registerLocale("fr", fr);

export function DateTimeField({
    availableDates,
    blockedDates,
    excludeDates,
    helperText,
    inline = false,
    inputRef,
    isError,
    label,
    locale = "fr",
    maxDate,
    minDate,
    name,
    onChange,
    portalId,
    value,
}: DateTimeFieldProps) {
    const { ref: calendarContainerRef, monthsShownLength } = useMonthsShown(inline);

    const handleTouchStart = useCallback((e: TouchEvent) => e.stopPropagation(), []);

    const handleCalendarOpen = () => {
        document.addEventListener("touchstart", handleTouchStart, true);
    };

    const handleCalendarClose = () => {
        document.removeEventListener("touchstart", handleTouchStart, true);
    };

    return (
        <div ref={calendarContainerRef}>
            <DatePicker
                calendarClassName={`${styles["calendar"]} ${timeStyles["calendar--time"]}`}
                customInput={
                    <Input inputName={name} inputRef={inputRef} isError={isError} label={label} />
                }
                dateFormat="EEEE d MMM HH'h'mm"
                excludeDates={excludeDates}
                formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 2)}
                highlightDates={[
                    { available: availableDates || [] },
                    { blocked: blockedDates || [] },
                ]}
                includeDates={availableDates}
                inline={inline}
                locale={locale}
                maxDate={maxDate || undefined}
                minDate={minDate || undefined}
                monthsShown={monthsShownLength}
                onCalendarClose={handleCalendarClose}
                onCalendarOpen={handleCalendarOpen}
                onChange={onChange}
                portalId={portalId || "resamare-calendar-root"}
                renderCustomHeader={(params) => (
                    <Header {...params} locale={locale} monthsShownLength={monthsShownLength} />
                )}
                renderDayContents={(day) => <Day day={day} />}
                selected={value}
                showTimeSelect
                timeCaption="Heure"
                timeClassName={() => timeStyles["time-list-item"]}
                timeFormat="HH'h'mm"
                timeIntervals={5}
                weekDayClassName={() => styles["weekday"]}
                withPortal={!inline}
            />
            {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
            {!portalId ? <DatePortal /> : null}
        </div>
    );
}
